//store notes limit change to 800 11-25-25
// import {
//   Box,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   Divider,
//   Grid,
//   IconButton,
// } from '@mui/material';
// import BakeasyLabelText from '../../components/labels/BakeasyLabelText';
// import { AppContext } from '../../context/AppContext';
// import { useAppDispatch, useAppSelector } from '../../redux_store/reduxStore';
// import {
//   createStoreNote,
//   OrderHistoryState,
// } from '../../redux_store/slices/OrderHistorySlice';
// import { formatDateTime } from '../../utils/DateUtils';
// import { t } from 'i18next';
// import { Close } from '@mui/icons-material';
// import * as TextField from '../../components/textfields/BakeasyTextFields';
// import React, { useEffect, useState } from 'react';
// import { BakeasyButton } from '../../components/buttons/BakeasyButton';

// interface StoreNotesHistoryProps {
//   from: string;
//   fetchMethod: any;
//   maxLength: number;
// }

// export const StoreNotesHistory: React.FC<StoreNotesHistoryProps> = ({
//   from,
//   fetchMethod,
// }) => {
//   let myContext = React.useContext(AppContext);
//   const dispatch = useAppDispatch();

//   const { selectedValue }: any = useAppSelector(
//     from === 'orderDetails'
//       ? OrderHistoryState
//       : () => ({ selectedValue: null })
//   );

//   const [note, setNote] = useState<string>('');
//   const [data, setData] = useState([]);

//   function handleClose() {
//     myContext.setDialog({ open: false });
//   }

//   async function handleSave() {
//     try {
//       const payload = { id: selectedValue?._id, note: note };
//       await dispatch(createStoreNote(payload));
//       await dispatch(fetchMethod({ id: selectedValue?._id }));
//       setNote('');
//     } catch (error) {
//       console.error('Failed to save', error);
//     }
//   }

//   useEffect(() => {
//     if (selectedValue && selectedValue.storeNotes) {
//       setData(selectedValue?.storeNotes);
//     }
//   }, [selectedValue]);

//   return (
//     <>
//       <DialogTitle
//         sx={{ margin: 0, padding: 2 }}
//         style={{ fontWeight: 600, fontSize: '1.2rem' }}
//         minWidth={200}
//       >
//         <Grid container sx={{ flexDirection: 'row' }}>
//           {t('STORE_NOTES')}
//         </Grid>
//       </DialogTitle>
//       <IconButton
//         onClick={handleClose}
//         sx={{
//           position: 'absolute',
//           right: 8,
//           top: 8,
//           color: (theme) => theme.palette.grey[500],
//         }}
//       >
//         <Close />
//       </IconButton>
//       <Divider />
//       <DialogContent sx={{ margin: 0 }}>
//         {data?.map((item: any, index: number) => (
//           <Grid key={index} sx={{ marginBottom: '15px' }}>
//             <BakeasyLabelText
//               label={formatDateTime(item.date)}
//               value={item.notes}
//             />
//           </Grid>
//         ))}
//       </DialogContent>
//       <Divider />
//       <DialogActions sx={{ margin: 1 }}>
//         <Box sx={{ flex: 1 }}>
//           <TextField.Description
//             label={t('NOTE')}
//             rows={2}
//             value={note}
//             maxLength={800}
//             onChange={(event: any) => setNote(event.target.value)}
//             fullWidth
//           />
//         </Box>

//         <Box
//           sx={{
//             display: 'flex',
//             flexDirection: 'column',
//             justifyContent: 'center',
//           }}
//         >
//           <BakeasyButton
//             fullWidth={false}
//             size="small"
//             variant="contained"
//             onClick={handleSave}
//             label={t('SAVE')}
//           />
//         </Box>
//       </DialogActions>
//     </>
//   );
//   // return (
//   //   <Grid sx={{ width: '400px' }} container padding={1}>
//   //     <Grid item xs={12}>
//   //       <BakeasyHeaderLabel message="Store Notes" />
//   //       <BakeasyDivider />
//   //     </Grid>
//   //     <Grid item xs={12} px={1}>
//   //       {data?.map((item: any, index: any) => (
//   //         <Grid
//   //           key={index}
//   //           sx={{
//   //             marginBottom: '15px'
//   //           }}
//   //         >
//   //           <BakeasyLabelText label={formatDateTime(item.date)} value={item.notes} />
//   //         </Grid>
//   //       ))}
//   //     </Grid>
//   //     <Grid
//   //       item
//   //       container
//   //       sx={{
//   //         position: 'sticky',
//   //         bottom: 0,
//   //         backgroundColor: 'white',
//   //         zIndex: 10,
//   //         padding: '0px',
//   //         width: '100%'
//   //       }}
//   //       xs={12}
//   //     >
//   //       <Grid width={'100%'} item>
//   //         <BakeasyTextField
//   //           label="NOTE"
//   //           type="text"
//   //           name="description"
//   //           value={note}
//   //           multiline
//   //           rows={1}
//   //           onChange={event => {
//   //             setNote(event.target.value);
//   //           }}
//   //         />
//   //       </Grid>

//   //       <Grid item container spacing={1} justifyContent="flex-end" m={1}>
//   //         <Grid item>
//   //           <BakeasyButton
//   //             fullWidth={false}
//   //             size="small"
//   //             variant="contained"
//   //             onClick={handleSave}
//   //             label="Save Note"
//   //           />
//   //         </Grid>
//   //         <Grid item>
//   //           <BakeasyButton
//   //             fullWidth={false}
//   //             size="small"
//   //             label="Cancel"
//   //             variant="outlined"
//   //             onClick={handleClose}
//   //           />
//   //         </Grid>
//   //       </Grid>
//   //     </Grid>
//   //   </Grid>
//   // );
// };

import {
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  DialogActions,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import BakeasyLabelText from '../../components/labels/BakeasyLabelText';
import { AppContext } from '../../context/AppContext';
import { useAppDispatch, useAppSelector } from '../../redux_store/reduxStore';
import {
  createStoreNote,
  OrderHistoryState,
} from '../../redux_store/slices/OrderHistorySlice';
import { formatDateTime } from '../../utils/DateUtils';
import { t } from 'i18next';
import { Close } from '@mui/icons-material';
import * as TextField from '../../components/textfields/BakeasyTextFields';
import { BakeasyButton } from '../../components/buttons/BakeasyButton';

interface StoreNotesHistoryProps {
  from: string;
  fetchMethod: any;
}

export const StoreNotesHistory: React.FC<StoreNotesHistoryProps> = ({
  from,
  fetchMethod,
}) => {
  let myContext = React.useContext(AppContext);
  const dispatch = useAppDispatch();

  const { selectedValue }: any = useAppSelector(
    from === 'orderDetails'
      ? OrderHistoryState
      : () => ({ selectedValue: null })
  );

  const [note, setNote] = useState('');
  const [data, setData] = useState([]);

  function handleClose() {
    myContext.setDialog({ open: false });
  }

  async function handleSave() {
    try {
      const payload = { id: selectedValue?._id, note };
      await dispatch(createStoreNote(payload));
      await dispatch(fetchMethod({ id: selectedValue?._id }));
      setNote('');
    } catch (error) {
      console.error('Failed to save', error);
    }
  }

  useEffect(() => {
    if (selectedValue?.storeNotes?.length) {
      setData(selectedValue.storeNotes);
    }
  }, [selectedValue]);

  return (
    <>
      {/* HEADER */}
      <DialogTitle
        sx={{ margin: 0, padding: 2 }}
        style={{ fontWeight: 600, fontSize: '1.2rem' }}
        minWidth={200}
      >
        <Grid container sx={{ flexDirection: 'row' }}>
          {t('STORE_NOTES')}
        </Grid>
      </DialogTitle>

      <IconButton
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Close />
      </IconButton>

      <Divider />

      {/* NOTES LIST */}
      <DialogContent sx={{ margin: 0 }}>
        {data?.map((item: any, index: number) => (
          <Grid key={index} sx={{ marginBottom: '15px' }}>
            <BakeasyLabelText
              label={formatDateTime(item.date)}
              value={item.notes}
            />
          </Grid>
        ))}
      </DialogContent>

      <Divider />

      {/* ADD NEW NOTE */}
      <DialogActions sx={{ p: 2, gap: 2 }}>
        <TextField.Description
          label={t('NOTE')}
          rows={2}
          value={note}
          maxLength={800}
          onChange={(e: any) => setNote(e.target.value)}
          fullWidth
        />

        <BakeasyButton
          fullWidth={false}
          size="small"
          variant="contained"
          onClick={handleSave}
          label={t('SAVE')}
        />
      </DialogActions>
    </>
  );
};
